<template>
  <div>
    <PublicShell :igreja="igreja" titulo="Ação Social" :valido="!!igrejaId" max-width="720px">
      <p class="pub-intro">Selecione o programa:</p>
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm12 lg12>
            <v-select outlined dense v-model="beneficiario.programaId" :items="programas" item-text="nome" item-value="id" color="#00695C" no-data-text="Nenhum programa disponível" @input="pegaProgramaSelecionado"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg12 v-if="programaSelecionado.detalhes">
            <v-alert type="warning" icon="info">{{ programaSelecionado.detalhes }}</v-alert>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <p class="pub-intro mt-2">Dados do membro:</p>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details type="tel" v-model="membro.cpf" @change="consultaCPF(membro.cpf)" append-outer-icon="search"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg8>
            <v-text-field light disabled v-model="membro.nome" label="NOME" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-text-field light disabled v-model="membro.celula" label="CÉLULA" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <p class="pub-intro mt-2">Dados da inscrição:</p>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-select outlined dense :disabled="!membro.nome" v-model="beneficiario.sexo" :items="sexos" hide-details color="#00695C" label="SEXO"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-text-field light :disabled="!membro.nome" v-model="beneficiario.whatsApp" label="WHATSAPP" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>

      <v-btn dark depressed block color="#00695C" rounded large class="mt-5" @click="salvaInscricao">Confirmar Cadastro</v-btn>
    </PublicShell>

    <v-dialog v-model="dialogoCadastroConcluido" persistent max-width="500px">
          <v-card>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="as-texto" style="color:#00695C">Inscrição realizada com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Concluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoNaoCadastrado" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="as-texto" style="color: #666">O CPF informado não possui cadastro na <strong>{{ igreja.nome }}</strong>. <a :href="`/cadastro-membro?igrejaId=${igrejaId}`">Clique aqui</a> e cadastre-se primeiro.<br><br>Depois, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoNaoCadastrado = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import moment from 'moment'
import axios from 'axios'
import PublicShell from '../../componentes/PublicShell.vue'

export default {
  name: 'AcaoSocialPublico',
  components: { Snackbar, Loading, PublicShell },
  data() {
    return {
      igrejaId: '',
      igreja: {},
      membro: { nome: '', celula: '', cpf: '', id: '' },
      beneficiario: { nome: '', cpf: '', sexo: '', programaId: '', membroId: '', igrejaId: '', whatsApp: '' },
      sexos: ['MASCULINO', 'FEMININO'],
      dialogoNaoCadastrado: false,
      dialogoCadastroConcluido: false,
      isLoading: false,
      fullPage: true,
      celulas: [],
      programas: [],
      programaSelecionado: [],
    }
  },
  mounted() {
    this.igrejaId = this.$route.query.igrejaId || ''
    if (this.igrejaId) {
      this.carregaDados()
      this.carregaCelulas()
      this.carregaProgramas()
    }
  },
  watch: {
    dialogoNaoCadastrado(val) { if (val === false) window.location.reload() },
  },
  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) {
          this.igreja = response.data
          this.beneficiario.igrejaId = response.data.id
        }
      } catch (error) {
        this.igrejaId = ''
      } finally {
        this.isLoading = false
      }
    },
    async carregaProgramas() {
      await axios.post(baseApiUrl + 'Programas/listarPublicos', null, { params: { igrejaId: this.igrejaId } })
        .then(response => {
          if (response.data) {
            for (let i = 0; i < response.data.length; i++) {
              if (moment(this.formatDateHora(response.data[i].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                this.programas.push(response.data[i])
              }
            }
          }
        })
    },
    async carregaCelulas() {
      await axios.post(baseApiUrl + 'Celulas/listarPublicas', null, { params: { igrejaId: this.igrejaId } })
        .then(response => { if (response.data) this.celulas = response.data })
    },
    async consultaCPF(cpf) {
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/buscaPublicaCpf', null, { params: { cpf: cpf, igrejaId: this.igrejaId } })
        .then(response => {
          if (response.data && response.data.id) {
            this.membro.nome = response.data.nome
            this.beneficiario.nome = response.data.nome
            this.membro.celula = response.data.celula && response.data.celula.nome
              ? response.data.celula.nome
              : this.nomeCelula(response.data.celulaId)
            this.beneficiario.cpf = response.data.cpf
            this.beneficiario.membroId = response.data.id
            this.beneficiario.whatsApp = response.data.telefone
            this.beneficiario.sexo = response.data.sexo
          } else {
            this.dialogoNaoCadastrado = true
          }
          this.isLoading = false
        })
    },
    formatDateHora(date) {
      if (!date) return null
      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + ' ' + date.substr(11, 8)
    },
    closeDialog() { window.location.reload() },
    async salvaInscricao() {
      const vm = this
      if (!this.beneficiario.nome || !this.beneficiario.sexo || !this.beneficiario.programaId || !this.beneficiario.membroId || !this.beneficiario.whatsApp) {
        vm.$refs.chamaSnackbar.snack('#F9A825', 'Preencha todos os campos para continuar!', 'ATENÇÃO')
      } else {
        this.isLoading = true
        if (await this.verificaInscricaoCpf(this.beneficiario.cpf)) {
          vm.$refs.chamaSnackbar.snack('#F9A825', 'Já existe uma inscrição do membro informado para este programa', 'ATENÇÃO')
          this.isLoading = false
        } else {
          await axios.post(baseApiUrl + 'beneficiarios/salvarPublico', this.beneficiario)
            .then(response => {
              if (response.data) {
                this.dialogoCadastroConcluido = true
                this.isLoading = false
              }
            })
        }
      }
    },
    nomeCelula(celulaId) {
      let nome
      this.celulas.filter(celula => { if (celula.id === celulaId) nome = celula.nome.trim() })
      return nome
    },
    async verificaInscricaoCpf(cpf) {
      let existe
      await axios.post(baseApiUrl + 'beneficiarios/verificaExistencia', null, { params: { cpf: cpf, programaId: this.beneficiario.programaId } })
        .then(response => {
          existe = !(!response.data || response.data.existe === false || response.data.count == 0)
        })
      return existe
    },
    pegaProgramaSelecionado() {
      for (let i = 0; i < this.programas.length; i++) {
        if (this.programas[i].id == this.beneficiario.programaId) this.programaSelecionado = this.programas[i]
      }
    },
  },
}
</script>

<style scoped>
.pub-intro { color: #5b6b67; margin: 0 0 6px; font-size: .95rem; }
.as-texto { font-weight: bold; color: #00253E; font-size: 17px; }
</style>
